"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = _default;

var _color = _interopRequireDefault(require("color"));

function _default(palette) {
  var primary = (0, _color["default"])(palette.elAccent).rgb(),
      borderColor = primary.alpha(0.87).string();
  return {
    animationBackgroundColor: primary.alpha(0.54).string(),
    color: palette.tAccent,
    background: palette.elPrimary,
    boxShadow: 'none',
    borderRadius: '2px',
    borderStyle: 'solid',
    borderWidth: '1px',
    borderColor: borderColor,
    focusColor: palette.tAccent,
    focusBorderColor: borderColor,
    focusBackground: palette.elPrimary,
    focusBoxShadow: 'none',
    hoverColor: palette.tAccent,
    hoverBorderColor: borderColor,
    hoverBackground: primary.alpha(0.16).string(),
    hoverBoxShadow: 'none',
    activeColor: palette.tAccentDark,
    activeBorderColor: borderColor,
    activeBackground: primary.alpha(0.38).string(),
    activeBoxShadow: 'none',
    disabledColor: palette.tDisabled,
    disabledBorderColor: palette.elDarkest,
    disabledBackground: 'transparent',
    disabledBoxShadow: 'none'
  };
}